import { createPublicApi } from "./api";

class UploadServices {
  constructor() {
    this.api = createPublicApi("/upload");
  }

  uploadfile(fileForm) {
    return this.api.post("/file", fileForm);
  }
}

const uploadServices = new UploadServices();

export default uploadServices;
